import React                           from 'react';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { ClipLoader }                  from 'react-spinners';
import { Accordion }                   from 'react-bootstrap';
import { LocalForm }                   from 'react-redux-form';
import { MdReceipt }                   from 'react-icons/md';
import { MdCheckCircle }               from 'react-icons/md';
import PubSub                          from 'pubsub-js';
import { EmployeeOnboardingConstants } from '../environment';
import { isLoggedIn, redirect }        from '../../../../utils/authService';
import { denyFetchData }               from '../../../../actions/employee-onboarding/deny';
import { receiptFetchData }            from '../../../../actions/employee-onboarding/receipt';
import { approveCheckFetchData }       from '../../../../actions/employee-onboarding/approve';
import { responsesFetchData }          from '../../../../actions/employee-onboarding/responses';
import { approveFetchData }            from '../../../../actions/employee-onboarding/approve';

var apiHost = EmployeeOnboardingConstants.WebApiHost;
var message = 'Thank you for responding to this request. If you would like a receipt, please click the icon below.';
var error   = 'There was an error processing your request.';
var deny    = 'Please take a moment to tell us why this request is being denied.';

class Approve extends React.Component {
    
  constructor(props) {
    super(props);
    this.state = {
      date       : '',
      message    : '',
      approve_id : '',
      deny_id    : '',
      sr         : '',
      notes      : '',
      reason     : '',
      completed  : false,
      error      : false,
      sent       : false,
      approved   : false
    };

    this.deny         = this.deny.bind(this);
    this.parseDn      = this.parseDn.bind(this);
    this.updateNotes  = this.updateNotes.bind(this); 
    this.updateReason = this.updateReason.bind(this); 
    this.receipt      = this.receipt.bind(this);
  }
  
  subscriberApprove(msg, result) {
    if (!this.props.approveIsLoading && !this.state.completed) {
      this.setState({ completed: true }, function() {
        var params = {
          approve_id : this.state.approve_id
        };
    
        this.props.fetchDataApproveCheck(apiHost, params);
      });
    }
  }
  
  subscriberDeny(msg, result) {
    if (!this.props.denyIsLoading && !this.state.completed) {
      this.setState({ completed: true }, function() {
        var params = {
          approve_id : this.state.approve_id
        };
    
        this.props.fetchDataApproveCheck(apiHost, params);
      });
    }
  }
  
  subscriberResponsesFirst(msg, result) {
    this.setState({ reason: result.Description });
  }
  
  subscriberApproveCheck(msg, result){
    if (result.Completed) {
      this.setState({ 
        message   : message, 
        approved  : result.Approved,
        date      : result.ModifiedDate,
        completed : true
      });
    }
    else if ('Completed' in result && !this.props.approveIsLoading && !this.props.denyIsLoading && !this.state.completed) {
      var params = {
        approve : this.state.approve_id,
        deny    : this.state.deny_id            
      };
      
      if (this.state.type === 'approve') {
        this.props.fetchDataApprove(apiHost, params);
      }
      else if (this.state.type === 'deny') {
        this.props.fetchDataResponses(apiHost, params);    
      }
      else {
        this.setState({ message: error, error: true });
      }
    } 
    else if (!this.props.approveIsLoading && !this.props.denyIsLoading) {
      this.setState({ message: error, error: true });
    }
  }

  deny(event) {
    const params = {
      approve_id : this.state.approve_id,
      deny_id    : this.state.deny_id,
      reason     : this.state.reason,
      notes      : this.state.notes
    };
    
    this.props.fetchDataDeny(apiHost, params);
    event.preventDefault();
  }

  parseDn(dn) {
    if (dn !== null && dn !== undefined) {
      var cn = dn.split(',')[0].split('=')[1].toLowerCase();
      return cn;
    }
  }

  updateNotes(event) {
    this.setState({ notes: event.target.value });
  }

  updateReason(event) {
    this.setState({ reason: event.target.value });
  }

  receipt() {
    var params = {
      approve_id : this.state.approve_id,
      action     : this.state.type
    };
    
    this.props.fetchDataReceipt(apiHost, params); 
  }

  componentDidMount() {
    this.tokenApproveCheck   = PubSub.subscribe('employee.approve.approveCheck', this.subscriberApproveCheck.bind(this));
    this.tokenResponsesFirst = PubSub.subscribe('employee.responses.first',      this.subscriberResponsesFirst.bind(this));
    this.tokenApprove        = PubSub.subscribe('employee.approve.approve',      this.subscriberApprove.bind(this));
    this.tokenDeny           = PubSub.subscribe('employee.approve.deny',         this.subscriberDeny.bind(this));
      
    if (!isLoggedIn()) {
      redirect(window.location.hash.replace("#/", ""));
      return;    
    }
    
    const query   = new URLSearchParams(window.location.hash);
    const approve = query.get('approve_id');
    const deny    = query.get('deny_id');
    const type    = query.get('type');
    const sr      = query.get('sr');

    this.setState({ approve_id: approve, deny_id: deny, sr: sr, type: type }, function() {
      var params = {
        approve_id : approve
      };
      
      this.props.fetchDataApproveCheck(apiHost, params);
    });
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.tokenApproveCheck);
    PubSub.unsubscribe(this.tokenResponsesFirst);
    PubSub.unsubscribe(this.tokenApprove);
    PubSub.unsubscribe(this.tokenDeny);
  }

  render() {
    var options = [];
    if (this.props.responses.Items) {
      for (var i = 1; i <= this.props.responses.Items.length; i++) {
        var response = this.props.responses.Items[i-1];
        options.push(
          <option key={i} value={response.Description}>{response.Description}</option> 
        );
      }
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.responsesIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.responsesIsLoading}
            />
            : <span />
          }
          { this.props.approveCheckIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.approveCheckIsLoading}
            />
            : <span />
          }
          { this.props.approveIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.approveIsLoading}
            />
            : <span />
          }
          { this.props.denyIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.denyIsLoading}
            />
            : <span />
          }
          { this.props.approveCheckHasErrored || (this.state.message && this.state.error) ?
            <Accordion className='well-red'>
              {error}
            </Accordion>
            : <span />
         }
       </div>
       { this.state.message && !this.state.error ?
          <div>
            <Accordion>
              <p>
                {this.state.message}
              </p>
              { this.state.completed ?
                <div>
                  <p><b>Status:</b> {this.state.approved ? 'Approved' : 'Denied'}</p> 
                  <p><b>Date:  </b> {this.state.date}</p> 
                </div>
                :
                <div></div>
              }
            </Accordion>
            { this.props.receiptIsLoading ?
              <div style={{marginLeft: '10px'}}>
                <ClipLoader
                  color={'#072659'}
                  loading={this.props.receiptIsLoading}
                />
              </div>
              :
              <button style={{marginLeft: '10px'}} onClick={this.receipt}>
                <MdReceipt size={24} style={{marginBottom: '20px'}} />
              </button>
            }
            { !this.props.receiptIsLoading && this.props.receipt.Success ?
              <MdCheckCircle size={24} color='green' />
              :
              <span />
            }
          </div>
          : <span />
       }
       { !this.props.approveCheckIsLoading && !this.props.approveIsLoading && !this.props.denyIsLoading && !this.state.completed && this.props.responses.Request ?
         <LocalForm>
           <Accordion>
             {deny}
           </Accordion>
           <div className='block'>
             <label>
               SR # &nbsp;
               <span style={{marginLeft: '40px'}} >{this.props.responses.Request.SR}</span>
             </label>
           </div>
           <div className='block'>
             <label>
               Employee &nbsp;
               <span style={{marginLeft: '8px'}} >{this.parseDn(this.props.responses.Request.Employee)}</span>
             </label>
           </div>
           <div className='block'>
             <label>
               Group &nbsp;
               <span style={{marginLeft: '30px'}} >{this.parseDn(this.props.responses.Request.Group)}</span>
             </label>
           </div>
           <div className='block'>
             <label>
               <b>Reason &nbsp;</b>
               <select selected={1} onChange={evt => this.updateReason(evt)} style={{fontWeight: 'normal'}}>
                 {options}
               </select>
             </label>
           </div>
           <div className='block'>
             <label>
               <b>Notes &nbsp;</b>
               <textarea onChange={evt => this.updateNotes(evt)} style={{fontWeight: 'normal'}} rows='4' cols='50' />
             </label>
           </div>
           <div style={{clear: 'both'}} className='block'>
             <button className="c-btn c-btn--sm" onClick={this.deny}>
               <span className="c-btn__text">Submit</span>
             </button>
           </div>
         </LocalForm>
         : <span />
       }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    deny: state.employee.deny.deny,
    denyHasErrored: state.employee.deny.denyHasErrored,
    denyIsLoading: state.employee.deny.denyIsLoading,
    receipt: state.employee.receipt.receipt,
    receiptHasErrored: state.employee.receipt.receiptHasErrored,
    receiptIsLoading: state.employee.receipt.receiptIsLoading,
    approveCheck: state.employee.approve.approveCheck,
    approveCheckHasErrored: state.employee.approve.approveCheckHasErrored,
    approveCheckIsLoading: state.employee.approve.approveCheckIsLoading,
    responses: state.employee.responses.responses,
    responsesHasErrored: state.employee.responses.responsesHasErrored,
    responsesIsLoading: state.employee.responses.responsesIsLoading,
    approve: state.employee.approve.approve,
    approveHasErrored: state.employee.approve.approveHasErrored,
    approveIsLoading: state.employee.approve.approveIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataDeny:         (host, params) => dispatch(denyFetchData(host, params)),
    fetchDataReceipt:      (host, params) => dispatch(receiptFetchData(host, params)),
    fetchDataApproveCheck: (host, params) => dispatch(approveCheckFetchData(host, params)),
    fetchDataResponses:    (host, params) => dispatch(responsesFetchData(host, params)),
    fetchDataApprove:      (host, params) => dispatch(approveFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Approve));
